import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sportsMeetingWarmup/Index.vue')
const Trend = () => import('../activity/sportsMeetingWarmup/Trend.vue')
const TrainingCamp = () => import('../activity/sportsMeetingWarmup/TrainingCamp.vue')
const InviteTeacher = () => import('../activity/sportsMeetingWarmup/InviteTeacher.vue')

export const sportsMeetingWarmupRoute: RouteConfig = {
  path: '/sports-meeting-warmup',
  name: 'sports_meeting_warmup',
  component: Index,
  meta: {
    title: '云上运动会',
  },
}

export const sportsMeetingWarmupTrendRoute: RouteConfig = {
  path: '/sports-meeting-warmup-trend',
  name: 'sports_meeting_warmup_trend',
  component: Trend,
  meta: {
    title: '学校火力榜',
  },
}

export const sportsMeetingWarmupTrainingCampRoute: RouteConfig = {
  path: '/sports-meeting-warmup-training-camp',
  name: 'sports_meeting_warmup_training_camp',
  component: TrainingCamp,
  meta: {
    title: '预热训练营',
  },
}

export const sportsMeetingWarmupInviteTeacherRoute: RouteConfig = {
  path: '/sports-meeting-warmup-invite-teacher',
  name: 'sports_meeting_warmup_invite_teacher',
  component: InviteTeacher,
  meta: {
    title: '云上运动会',
  },
}

export default [
  sportsMeetingWarmupRoute,
  sportsMeetingWarmupTrendRoute,
  sportsMeetingWarmupTrainingCampRoute,
  sportsMeetingWarmupInviteTeacherRoute,
]
